{
  "login": "Đăng nhập",
  "logout": "Đăng xuất",
  "signOut": "Đăng xuất",
  "username": "Tên đăng nhập",
  "password": "Mật khẩu",
  "forgotPassword": "Quên mật khẩu?",
  "rememberMe": "Ghi nhớ đăng nhập",
  "loginButton": "Đăng nhập",
  "loginError": "Tên đăng nhập hoặc mật khẩu không đúng",
  "sessionExpired": "Phiên làm việc đã hết hạn. Vui lòng đăng nhập lại.",
  "passwordChangedRelogin": "Your password was changed. Please sign in with your new password.",
  "signingIn": "Đang đăng nhập...",
  "loginSuccess": "Đăng nhập thành công",
  "showPassword": "Hiện mật khẩu",
  "hidePassword": "Ẩn mật khẩu",
  "onboardingPrompt": "Cho bệnh viện hoặc phòng khám?",
  "onboardingCta": "Yêu cầu triển khai",
  "loginFailed": "Đăng nhập thất bại",
  "seatCapReached": "Đã đạt giới hạn người dùng cho giấy phép này. Vui lòng liên hệ quản trị viên.",
  "mfaCodeLabel": "Mã xác minh",
  "mfaCodePrompt": "Nhập mã gồm 6 chữ số từ ứng dụng xác thực của bạn để hoàn tất đăng nhập.",
  "mfaSetupRequired": "Tổ chức của bạn yêu cầu xác thực đa yếu tố. Hãy thiết lập ứng dụng xác thực để tiếp tục.",
  "mfaCodePlaceholder": "Mã 6 chữ số",
  "mfaInvalidCode": "Mã xác minh không hợp lệ",
  "pages": {
    "userProfile": {
      "title": "Hồ sơ của tôi",
      "loading": "Đang tải hồ sơ...",
      "sections": {
        "profilePicture": "Ảnh đại diện",
        "personalInformation": "Thông tin cá nhân",
        "changePassword": "Đổi mật khẩu",
        "multiFactorAuth": "Xác thực đa yếu tố"
      },
      "fields": {
        "fullName": "Họ và tên",
        "email": "Email",
        "phone": "Điện thoại",
        "currentPassword": "Mật khẩu hiện tại",
        "newPassword": "Mật khẩu mới",
        "confirmPassword": "Xác nhận mật khẩu mới",
        "required": "*"
      },
      "actions": {
        "saveChanges": "Lưu thay đổi",
        "changePassword": "Đổi mật khẩu",
        "setUpMfa": "Thiết lập xác thực đa yếu tố",
        "uploadAvatar": "Tải lên",
        "changeAvatar": "Thay đổi",
        "removeAvatar": "Xoá",
        "verify": "Xác nhận"
      },
      "avatar": {
        "alt": "Ảnh đại diện",
        "helperText": "Hỗ trợ PNG, JPEG hoặc WebP, tối đa 4 MB. Được điều chỉnh về {{size}}×{{size}} trước khi tải lên."
      },
      "mfa": {
        "enabledMessage": "Tài khoản của bạn đã bật xác thực đa yếu tố.",
        "intro": "Bật xác thực đa yếu tố để tăng cường bảo mật cho tài khoản của bạn.",
        "scanInstruction": "Quét URI này bằng ứng dụng xác thực hoặc sao chép thủ công:",
        "copyUri": "Sao chép URI",
        "verificationCode": "Mã xác thực",
        "codePlaceholder": "Nhập mã 6 chữ số"
      },
      "validation": {
        "fullNameRequired": "Vui lòng nhập họ và tên",
        "emailRequired": "Vui lòng nhập email hợp lệ",
        "currentPasswordRequired": "Vui lòng nhập mật khẩu hiện tại",
        "newPasswordTooShort": "Mật khẩu phải có ít nhất 8 ký tự",
        "confirmPasswordRequired": "Vui lòng xác nhận mật khẩu",
        "passwordsMismatch": "Mật khẩu không khớp"
      },
      "toasts": {
        "profileUpdated": "Đã cập nhật hồ sơ",
        "profileUpdateFailed": "Cập nhật hồ sơ thất bại",
        "passwordChanged": "Đã đổi mật khẩu thành công",
        "passwordChangeFailed": "Đổi mật khẩu thất bại. Vui lòng kiểm tra mật khẩu hiện tại.",
        "mfaSetupFailed": "Không thể khởi tạo thiết lập xác thực đa yếu tố",
        "mfaEnabled": "Đã bật xác thực đa yếu tố",
        "mfaInvalidCode": "Mã xác thực không hợp lệ",
        "avatarUpdated": "Đã cập nhật ảnh đại diện",
        "avatarUpdateFailed": "Cập nhật ảnh đại diện thất bại",
        "avatarRemoved": "Đã xoá ảnh đại diện",
        "avatarRemoveFailed": "Xoá ảnh đại diện thất bại",
        "imageTooLarge": "Ảnh phải nhỏ hơn 4 MB",
        "imageTooLargeServer": "Ảnh quá lớn — vui lòng thử tệp nhỏ hơn",
        "copiedToClipboard": "Đã sao chép vào bộ nhớ tạm"
      }
    }
  },
  "components": {
    "sessionTimeoutWarning": {
      "critical": "Phiên của bạn sẽ hết hạn trong chưa đầy 1 phút. Hãy lưu công việc ngay.",
      "expiringSoon_one": "Phiên của bạn sẽ hết hạn trong {{count}} phút.",
      "expiringSoon_other": "Phiên của bạn sẽ hết hạn trong {{count}} phút.",
      "extendButton": "Gia hạn phiên"
    }
  },
  "signInMethod": "Sign-in method",
  "signInPassword": "Password",
  "signInDirectory": "Directory",
  "signInSso": "SSO",
  "ldapDirectory": "Directory",
  "ldapLoading": "Loading directories…",
  "ldapEmpty": "No directories configured — contact your administrator.",
  "ssoEmail": "Work email",
  "ssoEmailPlaceholder": "you@hospital.org",
  "ssoContinue": "Continue with SSO",
  "ssoChecking": "Checking…",
  "ssoChoose": "Choose your sign-in provider",
  "ssoContinueWith": "Continue with {{name}}",
  "ssoNoneFound": "No SSO provider for this domain — try password or directory sign-in.",
  "ssoCallbackTitle": "Completing sign-in…",
  "ssoCallbackFailed": "Single sign-on failed",
  "ssoCallbackMissing": "Missing sign-in response — please try again.",
  "ssoBackToLogin": "Back to sign-in",
  "setup": {
    "title": "Thiết lập ban đầu",
    "subtitle": "Tạo tài khoản quản trị viên đầu tiên cho bản cài đặt này.",
    "username": "Tên người dùng",
    "password": "Mật khẩu",
    "confirmPassword": "Xác nhận mật khẩu",
    "fullName": "Họ và tên (tùy chọn)",
    "fullNamePlaceholder": "VD: Nguyễn Văn An",
    "email": "Email (tùy chọn)",
    "submit": "Tạo tài khoản quản trị viên",
    "submitting": "Đang tạo tài khoản…",
    "usernameHint": "3–64 ký tự: chữ thường, chữ số, dấu chấm, gạch dưới và gạch ngang.",
    "passwordHint": "Ít nhất 12 ký tự, gồm chữ hoa, chữ thường, chữ số và ký tự đặc biệt.",
    "errUsername": "Dùng 3–64 ký tự: a–z, 0–9, dấu chấm, gạch dưới hoặc gạch ngang.",
    "errPasswordLength": "Mật khẩu phải có ít nhất 12 ký tự.",
    "errPasswordUpper": "Mật khẩu phải chứa chữ hoa.",
    "errPasswordLower": "Mật khẩu phải chứa chữ thường.",
    "errPasswordDigit": "Mật khẩu phải chứa chữ số.",
    "errPasswordSpecial": "Mật khẩu phải chứa ký tự đặc biệt.",
    "errConfirmRequired": "Vui lòng xác nhận mật khẩu.",
    "errConfirmMismatch": "Mật khẩu không khớp.",
    "errFullName": "Họ và tên không được quá 100 ký tự.",
    "errEmail": "Nhập địa chỉ email hợp lệ.",
    "successTitle": "Đã tạo tài khoản quản trị viên",
    "successBody": "Tài khoản “{{username}}” đã sẵn sàng. Đăng nhập để tiếp tục.",
    "goToLogin": "Đến trang đăng nhập",
    "claimedTitle": "Thiết lập đã hoàn tất",
    "claimedBody": "Hệ thống này đã có quản trị viên. Hãy đăng nhập bằng tài khoản của bạn.",
    "networkError": "Không thể kết nối đến máy chủ. Kiểm tra kết nối và thử lại.",
    "retry": "Thử lại",
    "rateLimited": "Thử quá nhiều lần. Chờ một phút rồi thử lại.",
    "usernameTaken": "Tên người dùng này đã được sử dụng.",
    "submitFailed": "Không thể tạo tài khoản. Vui lòng thử lại."
  }
}
